<template>
  <div class="dataList plr16">
    <div class="ptb16">
      <p style="font-weight: bold;">营业日报<span class="moneys fontSize14">(今日数据将在次日0点更新)</span></p>
    </div>
    <div class="">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs br10">
            <div class="titles">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>数据汇总</i></p>
              <v-historyDate @time="change" class="ml10"></v-historyDate>
            </div>
            <el-row class="rows">
              <el-col class="cols" :span="4">
                <p class="van-text">现金业绩</p>
                <p class="van-label">{{amount.achievementAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">实际业绩</p>
                <p class="van-label">{{amount.actualAchievementAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">洗脚双数</p>
                <p class="van-label">{{amount.footTotal}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">修护数</p>
                <p class="van-label">{{amount.repairTotal}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">产品数</p>
                <p class="van-label">{{amount.productTotal}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">其他数</p>
                <p class="van-label">{{amount.otherIncomeTotal}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">总数</p>
                <p class="van-label">{{amount.allTotal}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">免脚数</p>
                <p class="van-label">{{amount.freeFootTotal}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">洗脚客单</p>
                <p class="van-label">{{amount.footPrice}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">整体客单</p>
                <p class="van-label">{{amount.customerPrice}}</p>
              </el-col>

              <el-col class="cols" :span="4">
                <p class="van-text">洗脚业绩</p>
                <p class="van-label">{{amount.footTotalAchAmount}}</p>
              </el-col>
               <el-col class="cols" :span="4">
                <p class="van-text">修护业绩</p>
                <p class="van-label">{{amount.repairTotalAchAmount}}</p>
              </el-col>
               <el-col class="cols" :span="4">
                <p class="van-text">产品业绩</p>
                <p class="van-label">{{amount.productAchAmount}}</p>
              </el-col>
               <el-col class="cols" :span="4">
                <p class="van-text">其他业绩</p>
                <p class="van-label">{{amount.otherIncomeAchAmount}}</p>
              </el-col>
               <el-col class="cols" :span="4">
                <p class="van-text">新办会员卡</p>
                <p class="van-label">{{amount.addMemberTotal}}</p>
              </el-col>
               <el-col class="cols" :span="4">
                <p class="van-text">新办套餐卡</p>
                <p class="van-label">{{amount.addCardTotal}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">会员充值</p>
                <p class="van-label">{{amount.memberCardAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">会员消费</p>
                <p class="van-label">{{amount.memberCardConsumeAchAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">套餐卡洗脚数</p>
                <p class="van-label">{{amount.usedCardTotal}}</p>
              </el-col>
              
              <el-col class="cols" :span="4">
                <p class="van-text">今日店员</p>
                <p class="van-label">{{amount.workingTotal}}</p>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";

export default {
  mixins: [minxin],
  data() {
    return {
      amount: {},
      amountBO: {},
      paywaySetBOList: [],
      invoiceBOList: [],
      orderItemSumBOList: [],
      query: {
        beginTime: new Date(),
        endTime: new Date()
      }
    };
  },
  components: {},
  created() {
    
  },
  methods: {
    change(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      this.pageDetailByShop();
    },
    pageDetailByShop() {
      this.$api
        .post(this.$url.report.dailyBusinessReport, {
          beginTime: this.query.beginTime,
          endTime: this.query.endTime
        })
        .then(res => {
          this.amount = res;
        })
        .catch(error => {
          this.error = true;
        });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
</style>